import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-retailer-container',
  templateUrl: './retailer-container.component.html',
  styleUrls: ['./retailer-container.component.scss']
})
export class RetailerContainerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
